import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Users, Target, Grid, TrendingUp, Repeat, IndianRupee, Wallet, Megaphone, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import './MainTabNavigator.css';

const MainTabNavigator = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const cards = [
    { id: 'dashboard', title: 'Customer Master Data', icon: BarChart3, description: 'Overview of your marketing automation performance', path: '/dashboard' },
    { id: 'campaign-dashboard', title: 'Campaign Dashboard', icon: Target, description: 'Manage and monitor your marketing campaigns', path: '/campaign-dashboard' },
    { id: 'cohort-retention', title: 'Cohort Retention', icon: TrendingUp, description: 'Analyze customer retention patterns over time', path: '/cohort-retention' },
    { id: 'repeat-analysis', title: 'Repeat Analysis', icon: Repeat, description: 'Order frequency and orders by Month / Quarter', path: '/repeat-analysis' },
    { id: 'ltv-analysis', title: 'Spend Analysis', icon: Wallet, description: 'Average spend and customers by spend band', path: '/ltv-analysis' },
    { id: 'spend-analysis', title: 'LTV Analysis', icon: IndianRupee, description: 'Cohort LTV by Month / Quarter', path: '/spend-analysis' },
    { id: 'marketing-spend', title: 'Marketing Spend Analysis', icon: Megaphone, description: 'Daily and Monthly channel spend, orders, and GMV', path: '/marketing-spend' },
    { id: 'order-time-preference', title: 'Time Matrix', icon: Clock, description: 'Orders by hour and weekday for P1, P2, and the current 28-day period, in IST', path: '/order-time-preference' },
    { id: 'month-analytics', title: 'Month Analytics', icon: BarChart3, description: 'Analyze monthly trends for customer fields', path: '/month-analytics' },
    { id: 'user-management', title: 'User Management', icon: Users, description: 'Manage customer data and user interactions', path: '/user-management' },
    { id: 'matrix', title: 'Matrix', icon: Grid, description: 'Advanced data analysis and matrix operations', path: '/matrix', hidden: true }
  ];

  const handleCardClick = (path) => {
    navigate(path);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="main-tab-navigator">
      {/* Logout Button */}
      <motion.button
        className="logout-button"
        onClick={handleLogout}
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <span>⬅️</span>
      </motion.button>

      {/* Header */}
      <div className="tab-header">
        <h1 className="tab-title">Urvann BloomIQ</h1>
        <div className="tab-subtitle">Customer Intelligence Platform</div>
      </div>

      {/* Three Cards Container */}
      <div className="cards-container">
        {cards.filter((card) => !card.hidden).map((card, index) => {
          const IconComponent = card.icon;
          
          return (
            <motion.div
              key={card.id}
              className="card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              onClick={() => handleCardClick(card.path)}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-icon">
                <IconComponent size={32} />
              </div>
              <h3 className="card-title">{card.title}</h3>
              <p className="card-description">{card.description}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default MainTabNavigator;
